define.alias("ember-composable-helpers/helpers/toggle-action", "media/helpers/toggle-action");